var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"programme-page pt80"},[_c('transition',{attrs:{"name":"page","enter-active-class":"animate__animated animate__fadeIn","leave-active-class":"animate__animated animate__fadeOut"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }